import React from "react";
import { FaLongArrowAltRight } from "react-icons/fa";
import eventImg1 from "../../images/event-img1.jpeg";
import eventImg2 from "../../images/event-img2.jpeg";
import eventImg3 from "../../images/event-img3.jpeg";
import eventImg4 from "../../images/event-img4.jpg";

const Section3 = () => {
  const listItems = [
    {
      src: eventImg1,
      alt: "eventImg1",
      subhead: "Birthday",
      para: "Birthdays styled with care — playful, elegant, and just right.",
    },
    {
      src: eventImg2,
      alt: "eventImg2",
      subhead: "Baby Shower",
      para: "Celebrate new beginnings with thoughtful décor made for you.",
    },
    {
      src: eventImg3,
      alt: "eventImg3",
      subhead: "Bridal Shower",
      para: "Personalized styling to honor your bridal shower moments.",
    },
    {
      src: eventImg4,
      alt: "eventImg4",
      subhead: "Adult Celebrations",
      para: "Warm, thoughtful styling for your grown-up celebration.",
    },
  ];
  return (
    <div>
      <section className="event bg-light">
        <div className="container flow-content split">
          {listItems.map((items) => {
            return (
              <div className="event__listItem" key={items.alt}>
                <div>
                  <img src={items.src} alt={items.alt} />
                </div>
                <h3 className="section-subHead">{items.subhead}</h3>
                <p>{items.para}</p>
                <button className="section-links">
                  <span className="arrow__icon">
                    <FaLongArrowAltRight />
                  </span>
                  <span>Learn More</span>
                </button>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Section3;
